import { Tooth } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';

import { JawObject } from '@/entities/tooth';

export const getCombinedTeeth = (
  mainTeeth: Pick<
    JawObject,
    'quartile1' | 'quartile2' | 'quartile3' | 'quartile4'
  >,
  childTeeth: Pick<
    JawObject,
    | 'primaryQuartile1'
    | 'primaryQuartile2'
    | 'primaryQuartile3'
    | 'primaryQuartile4'
  >,
) => {
  const hasChildTeeth = Object.values(childTeeth).some(
    (quartile) => quartile.length > 0,
  );

  if (!hasChildTeeth) {
    return mainTeeth;
  }

  const quartileMapping = [
    { main: 'quartile1', child: 'primaryQuartile1' },
    { main: 'quartile2', child: 'primaryQuartile2' },
    { main: 'quartile3', child: 'primaryQuartile3' },
    { main: 'quartile4', child: 'primaryQuartile4' },
  ] as const;

  return quartileMapping.reduce(
    (combined, { main, child }) => {
      const childQuartileTeeth = childTeeth[child];

      if (!childQuartileTeeth || childQuartileTeeth.length === 0) {
        return combined;
      }

      const childTeethMap = childQuartileTeeth.reduce((map, tooth) => {
        const childISO = tooth.Numeration?.ISO ?? 0;
        const mainISO = childISO - 40;
        map.set(mainISO, tooth);
        return map;
      }, new Map<number, Tooth>());

      combined[main] = mainTeeth[main].map((mainTooth) => {
        const mainISO = mainTooth.Numeration?.ISO ?? 0;
        return childTeethMap.get(mainISO) || mainTooth;
      });

      return combined;
    },
    { ...mainTeeth },
  );
};
